// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2mCpQ{width:100%}._2mCpQ li+li{padding-top:.75rem}._1R56y{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}._1R56y h6{font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font)}@media(max-width:767px){._1R56y h6{font-size:16px;line-height:26px}}._2HOh_{max-width:calc(100% - 4.25rem)}._2H-T8{padding-bottom:.25rem}._2H-T8,._3szk4{display:block;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis}._3szk4{margin-top:.25rem;font-size:16px;font-weight:300;line-height:26px;font-family:var(--base-font)}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_2mCpQ",
	"flexWrapper": "_1R56y",
	"titleWrapper": "_2HOh_",
	"link": "_2H-T8",
	"progressText": "_3szk4"
};
module.exports = exports;
